import dynamic from 'next/dynamic'
import { DemographicsIcon } from 'src/components/insights/icons/demographics'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/education.png'

const DemographicsEducation = dynamic(() => import('src/components/insights/demographics/cards/education'), {
  ssr: false,
})

export const DemographicsEducationWidget: InsightBuilderWidget = {
  id: 'education',
  name: 'Education',
  type: 'Demographics',
  icon: DemographicsIcon,
  component: DemographicsEducation,
  supportedResultTypes: ['alphamap-location'],
  preview,
}
